// src/components/LoadingSpinner.jsx
import React from "react";
import CenteredSpinner from "./ui/CenteredSpinner";

export default function LoadingSpinner() {
  return (
    <div style={{ height: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <CenteredSpinner size={32} />
    </div>
  );
}
/*
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
*/
